import { render, staticRenderFns } from "./ArrivalPlaceNumber.vue?vue&type=template&id=33f0e743"
import script from "./ArrivalPlaceNumber.vue?vue&type=script&lang=js"
export * from "./ArrivalPlaceNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports